import React, { useState, useEffect } from "react";
import {
  Container,
  PageContainer,
  PageHeader,
  PageTitle,
} from "../../../styles/components";
import styled, { keyframes } from "styled-components";
import {
  currentInternsData,
} from "../../../data/mock/companyDashboard";
import CompanyNav from "../../../components/company/CompanyNav/CompanyNav.jsx";
import JobPostManagement from "../../../components/company/JobPostManagement/JobPostManagement.jsx";
import ApplicationsManagement from "../../../components/company/ApplicationsManagement/ApplicationsManagement.jsx";
import InternEvaluation from "../../../components/company/InternEvaluation/InternEvaluation.jsx";
import SuccessPopup from "../../../components/common/SuccessPopup.jsx";
import {
  WelcomeSection,
  WelcomeTitle,
  WelcomeText,
} from "../../../pages/Dashboard/components/ScadOfficeDashboard.jsx";
import InternDetails from "../../../components/company/InternDetails/InternDetails.jsx"; // Importing InternDetails component
// Animation keyframes
const titleGlow = keyframes`
  0% { text-shadow: 0 0 10px rgba(99, 102, 241, 0.5), 0 0 20px rgba(99, 102, 241, 0.3); }
  50% { text-shadow: 0 0 20px rgba(99, 102, 241, 0.8), 0 0 30px rgba(99, 102, 241, 0.5); }
  100% { text-shadow: 0 0 10px rgba(99, 102, 241, 0.5), 0 0 20px rgba(99, 102, 241, 0.3); }
`;

const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

// Styled components
const StyledPageContainer = styled(PageContainer)`
  position: relative;
  overflow: hidden;
  min-height: unset;
  padding: 2rem 0;
`;

const GlowingPageTitle = styled(PageTitle)`
  color: rgba(255, 255, 255, 0.95);
  position: relative;
  animation: ${titleGlow} 4s infinite ease-in-out,
    ${floatAnimation} 6s infinite ease-in-out;
  letter-spacing: 1px;

  &::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 2px;
    background: linear-gradient(90deg, rgba(99, 102, 241, 0.8), transparent);
    border-radius: 1px;
  }
`;

const SpaceBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  background-image: radial-gradient(
      1px 1px at 5% 5%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 25% 20%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 50% 5%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 75% 25%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 95% 15%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 10% 40%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 30% 65%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 55% 45%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 80% 70%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 90% 55%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 15% 80%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 35% 95%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 60% 85%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 85% 90%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    ),
    radial-gradient(
      1px 1px at 95% 80%,
      rgba(255, 255, 255, 0.6) 1px,
      transparent 0
    );
  opacity: 0.3;
`;

const StyledCard = styled.div`
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 16px;
  color: white;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 40px rgba(31, 38, 135, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  h3 {
    margin-top: 0;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: white;
  }

  p {
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 1.5rem;
  }

  button {
    background: linear-gradient(
      135deg,
      rgba(99, 102, 241, 0.8) 0%,
      rgba(79, 70, 229, 0.9) 100%
    );
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);

    &:hover {
      transform: translateY(-2px);
    }
  }
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

const InternListContainer = styled.div`
  margin-top: 1.5rem;
`;

const InternCard = styled.div`
  padding: 1rem;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    transform: translateX(5px);
  }

  h4 {
    margin: 0 0 0.5rem 0;
    color: white;
  }

  p {
    margin: 0 0 0.25rem 0;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
  }
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  background-color: ${(props) =>
    props.status === "pending"
      ? "rgba(245, 158, 11, 0.8)"
      : props.status === "reviewing"
      ? "rgba(59, 130, 246, 0.8)"
      : props.status === "interview"
      ? "rgba(16, 185, 129, 0.6)"
      : props.status === "accepted"
      ? "rgba(16, 185, 129, 0.8)"
      : props.status === "current intern"
      ? "rgba(5, 150, 105, 0.8)"
      : props.status === "internship complete"
      ? "rgba(79, 70, 229, 0.8)"
      : "rgba(239, 68, 68, 0.8)"};
  color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`;

// Filter button for intern status
const StatusFilterButton = styled.button`
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: ${(props) =>
    props.active ? "rgba(99, 102, 241, 0.8)" : "rgba(255, 255, 255, 0.1)"};
  color: white;
  border: 1px solid
    ${(props) =>
      props.active ? "rgba(99, 102, 241, 0.5)" : "rgba(255, 255, 255, 0.2)"};
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: ${(props) =>
    props.active ? "0 4px 12px rgba(99, 102, 241, 0.2)" : "none"};

  &:hover {
    background-color: ${(props) =>
      props.active ? "rgba(99, 102, 241, 0.9)" : "rgba(255, 255, 255, 0.2)"};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const CompanyDashboard = () => {
  const [activeView, setActiveView] = useState("dashboard");
  const [currentInterns, setCurrentInterns] = useState([]);
  const [selectedIntern, setSelectedIntern] = useState(null);
  const [showEvaluation, setShowEvaluation] = useState(false);
  const [showInternDetails, setShowInternDetails] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all"); // Add status filter state
  const [searchQuery, setSearchQuery] = useState(""); // Add search query state
  const [showSuccessPopup, setShowSuccessPopup] = useState(false); // New state for success popup
  const [popupMessage, setPopupMessage] = useState(""); // Message for the popup

  useEffect(() => {
    // In a real application, this would be an API call
    setCurrentInterns(currentInternsData);
  }, []);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle opening the evaluation form
  const handleEvaluateIntern = (intern) => {
    setSelectedIntern(intern);
    setShowEvaluation(true);
    setShowInternDetails(false);
  };

  // Handle viewing intern details
  const handleViewInternDetails = (intern) => {
    setSelectedIntern(intern);
    setShowInternDetails(true);
  };

  // Handle deleting an evaluation
  const handleDeleteEvaluation = (intern) => {
    // Update the interns list
    const updatedInterns = currentInterns.map(item => 
      item.id === intern.id ? { ...item, evaluation: undefined } : item
    );
    
    setCurrentInterns(updatedInterns);
    setSelectedIntern({ ...intern, evaluation: undefined });
    
    // Close the intern details modal
    setShowInternDetails(false);
    
    // Show success popup notification
    setPopupMessage(`Evaluation for ${intern.studentName} has been deleted successfully.`);
    setShowSuccessPopup(true);
    
    // Hide popup after 4 seconds
    setTimeout(() => {
      setShowSuccessPopup(false);
    }, 4000);
  };

  // Handle saving the evaluation
  const handleSaveEvaluation = (evaluation) => {
    // In a real app, this would save to the backend
    console.log(
      "Saving evaluation for",
      selectedIntern.studentName,
      evaluation
    );

    // Update the interns list with the new evaluation
    const updatedInterns = currentInterns.map(intern => 
      intern.id === selectedIntern.id ? { ...intern, evaluation } : intern
    );
    
    setCurrentInterns(updatedInterns);
    setSelectedIntern({ ...selectedIntern, evaluation });
    setShowEvaluation(false);

    // Show success popup notification
    setPopupMessage(
      `Evaluation for ${selectedIntern.studentName} has been saved successfully.`
    );
    setShowSuccessPopup(true);

    // Hide popup after 4 seconds
    setTimeout(() => {
      setShowSuccessPopup(false);
    }, 4000);
  };

  // View handlers for different dashboard sections
  const renderView = () => {
    switch (activeView) {
      case "dashboard":
        return (
          <>
            <WelcomeSection>
              <WelcomeTitle>Welcome to Company Dashboard</WelcomeTitle>
              <WelcomeText>
                Manage your internship postings, review applications, monitor
                current interns, and provide evaluations for completed
                internships.
              </WelcomeText>
            </WelcomeSection>

            <CardContainer>
              <StyledCard>
                <h3>Job Postings</h3>
                <p>
                  Create and manage internship opportunities for students. Track
                  applications and set requirements.
                </p>
                <button onClick={() => setActiveView("jobPosts")}>
                  Manage Job Posts
                </button>
              </StyledCard>
              <StyledCard>
                <h3>Applications</h3>
                <p>
                  Review student applications, schedule interviews, and select
                  candidates for internships.
                </p>
                <button onClick={() => setActiveView("applications")}>
                  View Applications
                </button>
              </StyledCard>{" "}
              <StyledCard>
                <h3>Current Interns</h3>
                <p>
                  Monitor active interns, track progress, and manage internship
                  completion.
                </p>
                <div style={{ marginTop: "3.2rem" }}>
                  {" "}
                  {/* Significantly increased spacing to push button down */}
                  <button onClick={() => setActiveView("interns")}>
                    Manage Interns
                  </button>
                </div>
              </StyledCard>
            </CardContainer>
          </>
        );

      case "jobPosts":
        return <JobPostManagement />;

      case "applications":
        return <ApplicationsManagement />;

      case "interns":
        return (
          <div>
            <PageHeader>
              <PageTitle>Current Interns Management</PageTitle>
            </PageHeader>
            <div style={{ marginTop: "2rem" }}>
              {" "}
              <div
                style={{
                  marginBottom: "1rem",
                }}
              >
                <h3>
                  {statusFilter === "all"
                    ? "All Interns"
                    : statusFilter === "current intern"
                    ? "Active Interns"
                    : "Completed Internships"}
                </h3>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "1.5rem",
                  background: "rgba(15, 23, 42, 0.3)",
                  padding: "0.75rem",
                  borderRadius: "10px",
                }}
              >
                <div style={{ display: "flex" }}>
                  <StatusFilterButton
                    active={statusFilter === "all"}
                    onClick={() => setStatusFilter("all")}
                  >
                    All Interns
                  </StatusFilterButton>
                  <StatusFilterButton
                    active={statusFilter === "current intern"}
                    onClick={() => setStatusFilter("current intern")}
                  >
                    Active Interns
                  </StatusFilterButton>
                  <StatusFilterButton
                    active={statusFilter === "internship complete"}
                    onClick={() => setStatusFilter("internship complete")}
                  >
                    Completed Internships
                  </StatusFilterButton>
                </div>
                <div>
                  <input
                    type="text"
                    placeholder="Search by name or position..."
                    style={{
                      padding: "0.5rem 1rem",
                      borderRadius: "8px",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      background: "rgba(255, 255, 255, 0.1)",
                      color: "white",
                      width: "250px",
                    }}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
              <InternListContainer>
                {currentInterns
                  .filter(
                    (intern) =>
                      (statusFilter === "all" ||
                        intern.status === statusFilter) &&
                      (searchQuery === "" ||
                        intern.studentName
                          .toLowerCase()
                          .includes(searchQuery.toLowerCase()) ||
                        intern.jobTitle
                          .toLowerCase()
                          .includes(searchQuery.toLowerCase()))
                  )
                  .map((intern) => (
                    <InternCard 
                      key={intern.id} 
                      onClick={() => handleViewInternDetails(intern)}
                    >
                      <div>
                        <h4>{intern.studentName}</h4>
                        <p>
                          <strong>Position:</strong> {intern.jobTitle}
                        </p>
                        <p>
                          <strong>University:</strong> {intern.university}
                        </p>
                        <p>
                          <strong>Period:</strong> {intern.startDate} to{" "}
                          {intern.endDate}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          gap: "0.5rem",
                        }}
                      >
                        <StatusBadge status={intern.status}>
                          {intern.status === "current intern"
                            ? "Active"
                            : "Completed"}
                        </StatusBadge>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleViewInternDetails(intern);
                          }}
                          style={{
                            padding: "0.4rem 0.75rem",
                            fontSize: "0.8rem",
                            background: "rgba(59, 130, 246, 0.8)",
                          }}
                        >
                          View Details
                        </button>
                        {intern.status === "internship complete" && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEvaluateIntern(intern);
                            }}
                            style={{
                              padding: "0.4rem 0.75rem",
                              fontSize: "0.8rem",
                              background: intern.evaluation 
                                ? "rgba(16, 185, 129, 0.8)" 
                                : "rgba(99, 102, 241, 0.8)",
                            }}
                          >
                            {intern.evaluation ? "Edit Evaluation" : "Evaluate"}
                          </button>
                        )}
                      </div>
                    </InternCard>
                  ))}

                {/* Display a message when no interns match the filter */}
                {currentInterns.filter(
                  (intern) =>
                    (statusFilter === "all" ||
                      intern.status === statusFilter) &&
                    (intern.studentName
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase()) ||
                      intern.jobTitle
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()))
                ).length === 0 && (
                  <div
                    style={{
                      padding: "2rem",
                      textAlign: "center",
                      background: "rgba(15, 23, 42, 0.3)",
                      borderRadius: "12px",
                      marginTop: "1rem",
                      color: "rgba(255, 255, 255, 0.7)",
                    }}
                  >
                    <div style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>
                      🔍
                    </div>
                    <h4 style={{ marginBottom: "0.5rem" }}>No interns found</h4>
                    <p>
                      There are no interns matching the current filter criteria.
                    </p>
                  </div>
                )}
              </InternListContainer>
            </div>
          </div>
        );

      default:
        return <div>Select an option from the navigation bar</div>;
    }
  };

  return (
    <StyledPageContainer>
      <SpaceBackground />
      <Container>
        <PageHeader>
          <GlowingPageTitle>Company Dashboard</GlowingPageTitle>
        </PageHeader>
        <CompanyNav activeView={activeView} onChangeView={setActiveView} />
        {renderView()}
        {/* Success Popup */}
        {showSuccessPopup && (
          <SuccessPopup
            message={popupMessage}
            duration={4000}
            onClose={() => setShowSuccessPopup(false)}
          />
        )}{" "}
        {/* Evaluation Modal */}
        {showEvaluation && selectedIntern && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.8)",
              backdropFilter: "blur(5px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
              paddingTop:
                "4rem" /* Adjusted padding to position below header */,
            }}
          >
            <div
              style={{
                background: "var(--bg-primary)",
                borderRadius: "16px",
                width: "90%",
                maxWidth: "800px",
                maxHeight:
                  "85vh" /* Increased from 80vh to 85vh for more height */,
                overflow: "auto",
                margin:
                  "60px auto 20px auto" /* Position below header with spacing */,
              }}
            >
              <InternEvaluation
                student={selectedIntern}
                onClose={() => setShowEvaluation(false)}
                onSave={handleSaveEvaluation}
                existingEvaluation={selectedIntern.evaluation}
                onDelete={handleDeleteEvaluation}
              />
            </div>
          </div>
        )}
        {/* Intern Details Modal */}
        {showInternDetails && selectedIntern && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.8)",
              backdropFilter: "blur(5px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
              paddingTop: "4rem",
            }}
          >
            <div
              style={{
                background: "var(--bg-primary)",
                borderRadius: "16px",
                width: "90%",
                maxWidth: "800px",
                maxHeight: "85vh",
                overflow: "auto",
                margin: "60px auto 20px auto",
              }}
            >
              <InternDetails
                intern={selectedIntern}
                onClose={() => setShowInternDetails(false)}
                onEvaluate={handleEvaluateIntern}
                onDeleteEvaluation={handleDeleteEvaluation}
              />
            </div>
          </div>
        )}
      </Container>
    </StyledPageContainer>
  );
};

export default CompanyDashboard;
